import React from "react";
import RegisterPageSection from "../sections/RegisterPageSection/Content";
const RegisterPage = () => {
  return <RegisterPageSection />;
};

export default RegisterPage;
